<template>
	<div class="mb-2">
		<div class="form-group input-content">
			<label class="show">Access</label>
			<!-- <label class="blue-link float-right"><button class="no-border blue-link cursor-pointer" @click="openTreeModal">+ New Access Group</button></label> -->
			<div class="input-wrap">
				<a @click="show_menu = !show_menu"> <input  type="text" disabled="true" v-model="selection.name" /> <button class="dropdown-button">&#9662;</button></a>
				<!-- <div class="height-max"> -->
				<div class="option-wrap" v-if="show_menu">
					<div class="option-display">
						
						<list-view-access :label="'Custom'" :selected_id="selected_id" :selection="selection" :accessList="accessList.custom" @selectItem="selectItem" :key="'Custom'"/>

						<list-view-access :label="'Location'" :selected_id="selected_id" 
						:selection="selection"
						:accessList="accessList.auto['Location']" @selectItem="selectItem" :key="'Location'"/>

						<list-view-access :label="'Discipline'" :selected_id="selected_id" :selection="selection" :accessList="accessList.auto['Discipline']" @selectItem="selectItem" :key="'Discipline'"/>

						<ul>
							<li :class="{'selected_item': selected_id.includes(all_list.id)}" @click="selectItem(all_list)"><p class="all_margin">All</p></li>
						</ul>
					</div>
				</div>
				<!-- </div> -->
			</div>
		</div>
	</div>
	
</template>

<script >
import ListViewAccess from './ListViewAccess';
export default {
	components: {
		ListViewAccess
	},
	props:['view','edit_user_selection'],
	computed:{
		current_agency(){
			return this.$route.params.agency_id
		}
	},
	data: function(){
		return{
			  selected: null,
			  show_menu:false,
			  selection:{
				  type:'',
				  name:''
			  },
			  show_modal:false,
			  accessList:'',
			  listHeaders: ['Location','Discipline'],
			  selected_id:[],
			  show_custom: false,
			  Location: false,
			  Discipline: false,
			  all_list:{
				  id:0,
				  name: 'All'
			  }
		}
	},
	created : function(){
		if(this.view == 'edit' && this.edit_user_selection != null){
			this.selectItem(this.edit_user_selection)
		}
		this.getAccessList();
	},
	methods : {
		openTab: function(header){
			console.log(header)
			if(header == 'Location'){
				this.Location = !this.Location
			}else{
				this.Discipline = !this.Discipline
			}
		},
		openCustom : function(){
			this.show_custom = !this.show_custom
		},
		getAccessList : function(){
			var params = {
				filters:{
					organization_id : this.current_agency,
				}
			}
			this.$store.dispatch('getAccessList',params).then((res)=>{
				this.accessList = res.data.data

            }).catch((error) => {
              // window.location.reload()
            })

		},
		openTreeModal(){ 
			this.$emit("openTreeModel")
		},
		selectItem(elem){
			console.log(elem)
			if(this.selected_id.length > 0 ){
				this.selected_id = []
			}
			this.selection = elem
			this.selected_id.push(elem.id)
			if(this.view == 'add'){
				this.$emit("userAccessGroupChange", elem)
			}else{
				this.$emit("userAccessGroupChangeEdit", elem)
			}
			this.show_menu = false
			
		}
	}
}
</script>
<style scoped src="../shared/assets/css/accessList.css">

</style>



// WEBPACK FOOTER //
// src/components/shared/AccessList.vue